import BaseRegulation, {BaseRegulationParams, IAccountData, StartSessionTimerContext} from "../base_regulation";
import TempAccountMessageRegulationHelper from "../../helpers/temp_account_message_helper";
import {GNWP_SOURCES} from "../../../../../../app-react/services/gnwp/gnwp-consts";
import {GermanyResponsibleGamingButtonPlacement} from "../../../../../../common/const/responsible-gaming";
import GenericRealityCheckMessageHandler from "../../helpers/generic_reality_check_message_handler";
import RealityCheckWithConfirmationMessageHandler from "../../helpers/reality_check_with_confirmation_message_handler";
import { REGULATION_STATUS_ID_MAP } from "../../regulation_const";

interface GermanyRegulationParams extends BaseRegulationParams {
    tempAccountMessageHelper?: TempAccountMessageRegulationHelper,
    placement?:GermanyResponsibleGamingButtonPlacement
}


export default class GermanyRegulation extends BaseRegulation {
    static CLASS = 'GermanyRegulation';

    init(params: GermanyRegulationParams) {
        super.init(params);
    }

    public getTempAccountGnwpSource() {
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

    showResponsibleIcons() {
        return this.serviceFactory.oAuth2Service().isAuthorized();
    }

    realityCheckEnabled() {
        return true;
    }

    sessionTimerEnabled() {
        return true;
    }

    isAnonymousPlayAllowed() : boolean {
        if(!this.serviceFactory.oAuth2Service().isAuthorized()) {
            return false;
        }

        return this._getAccountData().RegulationStatusId === REGULATION_STATUS_ID_MAP.APPROVED_FOR_REGULATION;
    }

    async showLoginMessage(): Promise<void> {
        if (this._IsDocUploadRequired()) {
            await this.serviceFactory.externalLinksProxyService().openUploadDocumentFromMyAccount();
        }
    }

    private _IsDocUploadRequired(){
        const accountData = this.serviceFactory.userService().getAccountData();
        return accountData.IsDocUploadRequired;
    }

    protected _getRealityCheckMessageHandler(context: StartSessionTimerContext): GenericRealityCheckMessageHandler {
        return RealityCheckWithConfirmationMessageHandler.create({
            serviceFactory: this.serviceFactory,
            realityCheckInterval: this.getRealityCheckInterval(),
            handleRealityCheckMessageCallback: this._handleRealityCheckMessage.bind(this),
            context: context
        });
    }

    /**
     * Overrides base class
     * @param sessionTimer
     * @private
     */
    async _handleRealityCheckMessage(sessionTimer, confirmCallback:Function): Promise<void> {

        this.serviceFactory.regulationService().showRealityCheckMessage().finally(() => {
            confirmCallback();
        });
    }

    isSessionCooldownEnabled(): boolean {
        return true;
    }

    private _getAccountData(): IAccountData {
        return this.serviceFactory.userService().getAccountData() as IAccountData;
    }

    isLoginPopupEnabled(): boolean {
        return true;
    }
}